import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Alert } from "@domestika-dev/prudencio/dist/atoms/Alert";
import { Box } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";

export const LiveSessionAlert = ({ message, type, isClosable, top, position }) => {
  return (
    <Box
      maxWidth={["500px", "800px", "800px"]}
      paddingX={[5]}
      left="50%"
      style={{ transform: "translateX(-50%)" }}
      position={position}
      top={top}
      zIndex={1055}
    >
      <Alert type={type} isClosable={isClosable}>
        <Text size="micro">
          <FormattedMessage id={message} />
        </Text>
      </Alert>
    </Box>
  );
};

LiveSessionAlert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isClosable: PropTypes.bool,
  top: PropTypes.number,
  position: PropTypes.string,
};

LiveSessionAlert.defaultProps = {
  isClosable: false,
  top: 1,
  position: "absolute",
};

export default LiveSessionAlert;
